import { sx } from './styles';
import { t } from '../../lib/i18n';
import type { Inbox } from '../../lib/types';

interface Props {
  inboxes: Inbox[];
  value: string | null;
  onChange: (id: string) => void;
}

export function InboxPicker({ inboxes, value, onChange }: Props) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={sx.label}>{t('settings.workingHours.selectInbox')}</label>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        style={{ ...sx.input, maxWidth: 320 }}
      >
        <option value="" disabled>
          {t('settings.workingHours.selectInbox')}
        </option>
        {inboxes.map((i) => (
          <option key={i.id} value={i.id}>
            {i.name} ({i.channel})
          </option>
        ))}
      </select>
    </div>
  );
}
